import { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import useActions from './useActions';

import { loadUser } from 'actions';

const useLoadUser = () => {
  const dispatchLoadUser = useActions(loadUser);
  const user = useSelector(
    ({ user }) => user,
  );

  const mustLoadUser = !user.user && user.token;

  const memoizedFetch = useCallback(() => {
    if (mustLoadUser)
      dispatchLoadUser()
  }, [dispatchLoadUser, mustLoadUser]);

  useEffect(() => {
    memoizedFetch();
  }, [memoizedFetch]);
  return user;
};

export default useLoadUser;
